import React, { useEffect, useState } from 'react'
import { Dropdown, OverlayTrigger, Spinner, Table, Tooltip } from 'react-bootstrap';
import useUtenti from '../../hooks/useUtenti';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomModal from '../../components/CustomModal/CustomModal';
import Userinfo from '../../components/UserInfo/UserInfo';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import CustomTable from '../../components/CustomTable/CustomTable';
import useUserConfigTable from '../../configTable/useUserConfigTable';
import { ACTION_TYPES } from '../../model/actions';

const BlacklistPage = () => {
    const {
      loadingStateUtenti,
      getUtenteByParams,
      setModalStateUtenti,
      modalStateUtenti,
      enableUtente
        } = useUtenti();
    const [blacklistUtenti, setBlacklistUtenti] = useState([]);
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const [selectedUtente, setSelectedUtente] = useState(null);
    const [selectedPage, setSelectedPage] = useState(1);
    const [formDataFilter, setFormDataFilter] = useState({});
    const [totalPages, setTotalPages] = useState(1);
    const [orderBy, setOrderBy] = useState(null);
    const [orderType, setOrderType] = useState(null);
    const [isLoadingBlacklistUtenti, setIsLoadingBlacklistUtenti] = useState(false);
    const userConfigTable = useUserConfigTable();
    const [selectedRow, setSelectedRow] = useState(null);

    const handleRowClick = (id) => {
      setSelectedRow(prevSelectedRow => prevSelectedRow === id ? null : id);
    };

    useEffect(() => {
      if (!isLoadingBlacklistUtenti) {
        printBlacklistUtenti();
      }
    }, [orderBy, orderType, selectedPage])

    const handlePageChange = (page) => {
      setSelectedPage(page);
    };

    const fetchBlacklistUtenti = async (obj) => {
      setIsLoadingBlacklistUtenti(true);
      obj = {
        ...obj,
        filtri: {
          ...obj.filtri,
        }
      };
    
      const fetchUtentiList = await getUtenteByParams(obj);
      const countPagination = Math.ceil(fetchUtentiList?.count / obj.limite);
      let utentiList = fetchUtentiList?.data ?? [];
      setTotalPages(countPagination);
      setBlacklistUtenti(utentiList);
      setIsLoadingBlacklistUtenti(false);
      if(utentiList?.length === 0){
        setSelectedPage(1)
      }
    }


    const printBlacklistUtenti = async () => {
      let obj = {
         filtri: {
          ...formDataFilter,
          attivo: 0
          },
        limite: 10,
        pagina: selectedPage ?? 1,
        ordinamento: `${orderBy ?? "nome"} ${orderType ?? "asc"}`
      };
    
      await fetchBlacklistUtenti(obj);
    };
  
  const onFilteredTable = async () => {
    setSelectedPage(1);
    let obj = {
      filtri: {
        ...formDataFilter,
        attivo: 0
      },
      limite: 10,
      pagina: 1,
      ordinamento: `${orderBy ?? "nome"} ${orderType ?? "asc"}`
    };
    await fetchBlacklistUtenti(obj);
  };

    const openInfoModal = (user) => {
      setSelectedUtente(user);
      setModalStateUtenti((state) => ({ ...state, showModalInfoUtente: true }));
    };

    const handleCloseModal = () => {
      setSelectedUtente(null);
      setModalStateUtenti((state) => ({
        ...state,
        showModalInfoUtente: false,
        showModalEnableUtente: false,
      }));
    };

    const handleOrder = (orderBy, orderType) => {
      setOrderBy(orderBy);
      setOrderType(orderType);
    };

    const openEnableModal = (user) => {
      setSelectedUtente(user);
      setModalStateUtenti((state) => ({ ...state, showModalEnableUtente: true }));
    };


    const renderSelectedEnableUtente = () => (
        <>
          <span className="d-block fs-4 mb-2">
            <b>Vuoi riabilitare il seguente utente?</b>
          </span>
          <span className="d-block fs-5">
            {selectedUtente?.nome} {selectedUtente?.cognome}{" "}
            <span className="fs-6 small text-muted">
              ({selectedUtente?.username})
            </span>
          </span>
        </>
    )

    const onEnableUtente = async () => {
      const obj = { username: selectedUtente?.username };
      const res = await enableUtente(obj);
      if (res) {
        setModalStateUtenti((state) => ({
          ...state,
          showModalEnableUtente: false,
        }));
        printBlacklistUtenti();
      }
    }
    
    const actions = [
      {
        label: ACTION_TYPES.DETAILS,
        icon: 'bi-info-circle text-dark',
        type: ACTION_TYPES.VIEW,
        tooltip: ACTION_TYPES.DETAILS,
        condition: () => true,
        onClick: (user) => openInfoModal(user)
      },
      {
        label: "Riabilita utente",
        icon: 'bi-person-fill-slash text-success',
        tooltip: 'Riabilita utente',
        type: ACTION_TYPES.MANAGER,
        condition: () => true,
        onClick: (user) => openEnableModal(user)
      }
    ]

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{minHeight: '920px'}}>
                <div className='container' style={{height: "100%"}}>
                  <div className='d-flex justify-content-between custom-card-header'>
                    <div className='d-flex gap-3 custom-card-title my-2'>
                      <div className={`custom-icon-container`}>
                        <i className={`bi custom-icon bi-person-fill-slash fs-2`}></i>
                      </div>
                      <div className='align-self-center'>
                        <span className='fs-4 d-block'><i><b>Blacklist utenti</b></i></span>
                      </div>
                    </div>
                  </div>
                  <div className='mt-5'>
                      <CustomFilterTable 
                        formDataFilter={formDataFilter}
                        setFormDataFilter={setFormDataFilter}
                        onFilteredTable={onFilteredTable}
                        isLoadingData={loadingStateUtenti.isLoadingUtenteByParams}
                        searchNodeType={[
                          {nodeType: "input", name: "nome"},
                          {nodeType: "input", name: "cognome"},
                          {nodeType: "input", name: "username"},
                          {nodeType: "select", name: "tipo_utente"}
                        ]}
                      />
                  </div>
                  {  !loadingStateUtenti.isLoadingUtenteByParams ? (
                    <>
                  {(!blacklistUtenti || blacklistUtenti.length === 0) ? (
                    <div className='mt-5 pt-5 text-center'>
                        <p>Non ci sono utenti da mostrare.</p>
                    </div>
                    ) : (
                      <>
                      <CustomTable
                        data={blacklistUtenti}
                        actions={actions}
                        columns={userConfigTable}
                        handleOrder={handleOrder}
                        orderBy={orderBy}
                        orderType={orderType}
                      />
{/*                   <Table responsive striped className='mt-4' bordered hover>
                  <thead className='bg-dark text-light'>
                  <tr>
                  <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Nome
                      {orderBy === "nome" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "nome" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("nome", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("nome", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                    </div>
                    </th>
                  <th scope="col">
                    <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Cognome
                      {orderBy === "cognome" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                      {orderBy === "cognome" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("cognome", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("cognome", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                    </div>
                    </th>
                  <th scope="col">
                  <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Ruolo
                      {orderBy === "tipo_utente" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                    {orderBy === "tipo_utente" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("tipo_utente", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("tipo_utente", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                    </div>
                  </th>
                  <th scope="col">
                  <div className='d-flex justify-content-between'>
                      <span className='align-self-center'>Email
                      {orderBy === "username" && orderType === "asc" && (<i className="bi bi-arrow-up ms-1"></i>)}
                    {orderBy === "username" && orderType === "desc" && (<i className="bi bi-arrow-down ms-1"></i>)}
                      </span>
                      <Dropdown>
                    <Dropdown.Toggle size="sm" variant='secondary'>
                    <i className="bi bi-list"></i>
                    </Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleOrder("username", "asc")}><i className="bi bi-arrow-up me-1"></i> Ascendente</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleOrder("username", "desc")}><i className="bi bi-arrow-down me-1"></i> Discendente</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                    </div>
                  </th>
                  <th scope="col" style={{alignContent: "center"}}>
                      <div className="text-end">
                       Azioni
                      </div>
                    </th>
                  </tr>
                    </thead>
                    <tbody>
                    {blacklistUtenti?.map(utente => (
                      <tr key={utente.id_utente} className={selectedRow === utente.id_utente ? 'selected-row' : ''} onClick={() => handleRowClick(utente.id_utente)}>
                      <td>{utente?.nome}</td>
                      <td>{utente?.cognome}</td>
                      <td>{utente?.tipo_utente === "course_designer" ? "course designer" : utente?.tipo_utente}</td>
                      <td>{utente?.username}</td>
                      <td className='text-end'>
                      <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-info">Mostra informazioni utente</Tooltip>}
                          >
                              <i role="button" onClick={() => openInfoModal(utente)} className="bi bi-info-circle fs-5 mx-1 text-dark"></i>
                          </OverlayTrigger>
                          <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip id="tooltip-disable">Riabilita utente</Tooltip>}
                            >
                              <i role="button" onClick={() => openEnableModal(utente)} className="bi bi-person-fill-check fs-5 mx-1 text-success"></i>
                            </OverlayTrigger>
                        
         
                      </td>
                    </tr>
                    ))}
                  </tbody>
               </Table> */}
               <div className="d-flex justify-content-end mt-1">
               <CustomPagination
                  totalPages={totalPages}
                  selectedPage={selectedPage}
                  handlePageChange={handlePageChange}
                  />
                </div>
              </>
                    )
                  }
               </>
              ) : (
              <LoadingTable 
              loadingCol={4}
              />
              ) }
          </div>
      </div>
     <CustomModal
        show={modalStateUtenti.showModalInfoUtente}
        onHide={handleCloseModal}
        headerText="Informazioni utente"
        size={"lg"}
        body={<Userinfo userData={selectedUtente} />}
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />
     <CustomModal
        show={modalStateUtenti.showModalEnableUtente}
        onHide={handleCloseModal}
        headerText="Riabilita utente"
        size={"md"}
        btnText={"Riabilita"}
        variant={"success"}
        body={renderSelectedEnableUtente()}
        isLoading={loadingStateUtenti.isLoadingUtentiEnable}
        closeButton={true}
        onUndoChanges={handleCloseModal}
        onSave={onEnableUtente}
      />
        </>
      )
}

export default BlacklistPage;